import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import ConfigurableBackground from './_configurable-background.js'
import ConfigurableText from './_configurable-text.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import Button from './_button.js'
import Text from './_text.js'
import RotatableImage from './_rotatable-image.js'
import SportIcons from './_sport-icons.js'
import HideablePane from './_hideable-pane.js'

export default {
  name: 'SportsMenuView',
  values: {
    highlightedSports: {
      maxAmount: 5,
      show: true,
      _mobile_show: false,
    },
    header: {
      show: true,
      _mobile_show: false,
    },
    toggleButton: {
      show: true,
      _mobile_show: false,
    },
    separator: {
      show: false,
    },
    listTitle: {
      show: false,
    },
    showVirtuals: false,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    sportContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    style: {
      header: {
        height: '40px',
        padding: '8px',
        icon: {
          configSet: Image,
          configValues: {},
        },
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      headerText: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      separator: {
        width: '100%',
        height: '1px',
        margin: '6px 0 6px 0',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      listTitle: {
        margin: '20px 0 10px 40px',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      toggleButton: {
        minHeight: '40px',
        padding: '0 0 0 8px',
        expanded: undefined,
        transition: 'opacity 0.2s',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
    },
    sportItem: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            alignItems: 'center',
            justifyContent: 'left',
            flexGrow: 1,
            minHeight: '40px',
            padding: '0 0 0 8px',
          },
        },
      },
    },
    favoriteIconButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '40px',
            minHeight: '40px',
          },
        },
      },
    },
    itemIcon: {
      configSet: Image,
      configValues: {
        style: {
          flexBasis: '24px',
          alignSelf: 'stretch',
          padding: '0 8px 0 0',
        },
      },
    },
    itemContainer: {
      configSet: Text,
      configValues: {
        container: {
          flexBasis: '0%',
        },
        style: {
          wordBreak: 'break-all',
        },
      },
    },
    favoriteIconToggled: {
      configSet: Image,
      configValues: {
        src: 'star-filled',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    favoriteIcon: {
      configSet: Image,
      configValues: {
        src: 'star-outlined',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    rotation: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '8px',
            minHeight: '6px',
          },
        },
        style: {
          margin: '0 8px 0 0',
        },
      },
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    allSportsContainer: {
      configSet: HideablePane,
      configValues: {
        style: {
          innerContainer: {
            flexDirection: 'column',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
